module.exports = __webpack_public_path__ + "img/sound-off.fa1e7dc5.svg";